import CollapseMenu from '@/components/common/collapse-menu/collapse-menu';
import InfoTwoLinesBlock from '@/components/common/info-two-lines-block/info-two-lines-block';
import useGetAvatar from '@/hooks/useGetAvatar';
import useGetAvatarProperties from '@/hooks/useGetAvatarProperties';
import { composeUri } from '@/utils/compose';
import {
    AVATARS,
    CONTACT_EMAIL_AVATAR_PROPERTY,
    CONTACT_NAME_AVATAR_PROPERTY,
    CONTACT_PHONE_AVATAR_PROPERTY,
    SITES,
} from '@/utils/CONST';
import { toShortFormatDate } from '@/utils/date';
import { getAvatarPropertyValue } from '@/utils/getProperty';
import { HomeWorkOutlined } from '@mui/icons-material';
import { Skeleton } from '@mui/material';
import Box from '@mui/material/Box';
import { useTranslate } from 'react-admin';
import { useParams } from 'react-router';

const SiteDetails = () => {
    const { siteId, clientId } = useParams();
    const { avatar, isLoading: isLoadingAvatar } = useGetAvatar({
        avatarUriId: composeUri(AVATARS, siteId),
        queryKey: `${SITES}_${clientId}`,
    });
    const { properties, isLoading: isLoadingProperties } = useGetAvatarProperties({
        avatarId: composeUri(AVATARS, siteId),
        propertiesNames: [CONTACT_NAME_AVATAR_PROPERTY, CONTACT_PHONE_AVATAR_PROPERTY, CONTACT_EMAIL_AVATAR_PROPERTY],
    });

    const translate = useTranslate();
    const isLoading = isLoadingAvatar || isLoadingProperties;

    if (isLoading) {
        return (
            <CollapseMenu icon={<HomeWorkOutlined />} text={translate('main.loading')}>
                <Box sx={{ display: 'grid', gap: 1, p: 1 }}>
                    {[1, 2, 3, 4, 5, 6].map((i) => (
                        <Skeleton key={i} height={32} />
                    ))}
                </Box>
            </CollapseMenu>
        );
    }

    if (!avatar) {
        return null;
    }

    return (
        <CollapseMenu icon={<HomeWorkOutlined />} text={avatar?.name}>
            <Box
                sx={{
                    display: 'grid',
                    gap: 1,
                    p: 1,
                }}
            >
                <InfoTwoLinesBlock
                    title={translate('site.form.address')}
                    subtitle={avatar?.addressText}
                    id={'address'}
                />

                <InfoTwoLinesBlock title={translate('site.form.city')} subtitle={avatar?.city} id={'city'} />

                <InfoTwoLinesBlock
                    title={translate('site.form.postalCode')}
                    subtitle={avatar?.postalCode}
                    id={'city'}
                />

                <InfoTwoLinesBlock title={translate('site.form.country')} subtitle={avatar?.country} id={'country'} />

                <InfoTwoLinesBlock
                    title={translate('site.installation_date')}
                    subtitle={toShortFormatDate(avatar?.creationDate)}
                    id={'date'}
                />

                <InfoTwoLinesBlock
                    title={translate('site.contact_info')}
                    subtitle={[
                        getAvatarPropertyValue(properties, CONTACT_NAME_AVATAR_PROPERTY) as string,
                        getAvatarPropertyValue(properties, CONTACT_PHONE_AVATAR_PROPERTY) as string,
                        getAvatarPropertyValue(properties, CONTACT_EMAIL_AVATAR_PROPERTY) as string,
                    ]}
                    id={'contact_info'}
                />
            </Box>
        </CollapseMenu>
    );
};

export default SiteDetails;
